export const getFormattedValidationErrorFromAction = (action) => {

  if (!action || !action.error || !action.error.response) {
    return null
  }

  const {
    response: {
      data: { errors = null, messages = null } = null,
      status: statusCode
    }
  } = action.error
  const getFirstOnly = (array, param) => ((array && array.length > 0 && array[0][param]))
  const messageError = getFirstOnly(errors, 'message') || getFirstOnly(messages, 'description') || ''
  const subMessageError = getFirstOnly(errors, 'subMessage') || ''
  const code = getFirstOnly(errors, 'code') || ''
  const subs = getFirstOnly(errors, 'sub') || []
  const errorData = {
    code,
    message: messageError,
    subMessage: subMessageError,
    subs,
    subSkus: subs.filter(s => s.type === code).map(s => s.message),
    statusCode,
    errorSkus: errors[0]?.errorSkus
  }
  return errorData
}

export const getErrorData = (action) => {
  if (action && action.error && action.error.response && action.error.response.data) {
    return action.error.response.data.errors;
  }
  return null;
}